import { formatDateDDMMYYYY } from "../../utils/dateFunctions";
import { IParameter } from "../types";
import { IGetParamsGET_FORECAST_JSON } from "./types";

function getParamsGET_FORECAST_JSON({
    NSTOP_ID,
    NONLY_LOWFLOOR = false,
    dDATE = formatDateDDMMYYYY(new Date().toString()),
}: IGetParamsGET_FORECAST_JSON): IParameter[] {
    return [
        { name: "NSTOP_ID", value: NSTOP_ID },
        { name: "NONLY_LOWFLOOR", value: NONLY_LOWFLOOR ? 1 : null },
        { name: "dDATE", value: dDATE },
    ];
}

function getParamsGET_POINTS_JSON(NPART_ID: string): IParameter[] {
    return [
        { name: "NPART_ID", value: NPART_ID },
    ];
}

function getParamsGET_ROUTES_LISTS(): IParameter[] {
    return [
        {
            "name": "NAKK_ID",
            "value": null
        },
        {
            "name": "CROUTES_ID_LIST",
            "value": null
        },
        {
            "name": "CFILTER",
            "value": ""
        },
        {
            "name": "NFIRST_ROWNUM",
            "value": 1
        },
        {
            "name": "NLAST_ROWNUM",
            "value": 2000000
        },
        {
            "name": "NRL_ID",
            "value": null
        }
    ];
}

function getParamsGET_R_PARTS(NRL_ID: number, dDATE: string): IParameter[] {
    return [
        {
            "name": "NRL_ID", // маршртут
            "value": NRL_ID
        },
        {
            "name": "dDATE", // дата
            "value": dDATE
        },
    ];
}

export {
    getParamsGET_FORECAST_JSON,
    getParamsGET_POINTS_JSON,
    getParamsGET_ROUTES_LISTS,
    getParamsGET_R_PARTS,
};